<form #form="ngForm" novalidade>
    <div class="card">
        <div class="card-header">
            <h6 class="card-title mb-0">
                Pedidos
            </h6>
           <small class="card-subtitle">Selecione as permissões que este usuário tem acesso no lançamento dos pedidos</small>
        </div>
        
        <ul class="list-group list-group-flush" *ngIf="entity">
            <li class="list-group-item disabled" aria-disabled="true">
                <div class="list-group-item-title">Ações</div>
                <small class="list-group-item-value">
                    Ações que pode ser executadas nos pedido
                </small>
            </li>
            <li class="list-group-item">
                <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" [(ngModel)]="entity.podeConfirmarPedido" name="podeConfirmarPedido" id="podeConfirmarPedido">
                    <label class="custom-control-label" for="podeConfirmarPedido">Confirmar Pedidos</label>
                </div>
                <p class="form-text text-muted">Selecione esta opção para permitir o usuário confirmar pedidos com o status "Não Confirmado"</p>
            </li>

            <li class="list-group-item" *ngIf="!isPerfilRepresentante">
                <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" [(ngModel)]="entity.podeLiberarPedido" name="podeLiberarPedido" id="podeLiberarPedido">
                    <label class="custom-control-label" for="podeLiberarPedido">Liberar Pedidos</label>
                </div>
                <p class="form-text text-muted">Selecione esta opção para permitir o usuário liberar pedidos com o status "Não Liberado"</p>
            </li>

            <li class="list-group-item">
                <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" [(ngModel)]="entity.podeEditarPedidoNaoLiberado" name="podeEditarPedidoNaoLiberado" id="podeEditarPedidoNaoLiberado">
                    <label class="custom-control-label" for="podeEditarPedidoNaoLiberado">Editar Pedidos Não Liberados</label>
                </div>
                <p class="form-text text-muted">Selecione esta opção para permitir o usuário editar pedidos com o status "Não Liberado"</p>
            </li>

            <li class="list-group-item">
                <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" [(ngModel)]="entity.podeEditarPedidoConfirmado" name="podeEditarPedidoConfirmado" id="podeEditarPedidoConfirmado">
                    <label class="custom-control-label" for="podeEditarPedidoConfirmado">Editar Pedidos Confirmados</label>
                </div>
                <p class="form-text text-muted">Selecione esta opção para permitir o usuário editar pedidos com o status "Confirmado"</p>
            </li> 

            <li class="list-group-item">
                <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" [(ngModel)]="entity.podeEditarPedidoComissao" name="podeEditarPedidoComissao" id="podeEditarPedidoComissao">
                    <label class="custom-control-label" for="podeEditarPedidoComissao">Editar Comissões</label>
                </div>
                <p class="form-text text-muted">Selecione esta opção para permitir o usuário editar as comissões dos pedidos</p>
            </li>   

            <li class="list-group-item">
                <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" [(ngModel)]="entity.podeEditarEntregas" name="podeEditarEntregas" id="podeEditarEntregas">
                    <label class="custom-control-label" for="podeEditarEntregas">Editar Entregas</label>
                </div>
                <p class="form-text text-muted">Selecione esta opção para permitir o usuário editar as entregas dos itens dos pedidos</p>
            </li>             
            
            <li class="list-group-item">
                <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" [(ngModel)]="entity.podeExportarErp" name="podeExportarErp" id="podeExportarErp">
                    <label class="custom-control-label" for="podeExportarErp">Exportar para o ERP</label>
                </div>
                <p class="form-text text-muted">Selecione esta opção para permitir o usuário exportar pedidos para o ERP</p>
            </li>
            <li class="list-group-item">
                <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" [(ngModel)]="entity.podeRevisarPedidoOrcamento" name="podeRevisarPedidoOrcamento" id="podeRevisarPedidoOrcamento">
                    <label class="custom-control-label" for="podeRevisarPedidoOrcamento">Revisar Pedidos e Orçamentos</label>
                </div>
                <p class="form-text text-muted">Selecione esta opção para permitir o usuário revisar os pedidos e orçamentos</p>
            </li>                 
            <li class="list-group-item">
                <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" [(ngModel)]="entity.podeInformarValidadePropostaComercial" name="podeInformarValidadePropostaComercial" id="podeInformarValidadePropostaComercial">
                    <label class="custom-control-label" for="podeInformarValidadePropostaComercial">Informar Validade da Proposta Comercial</label>
                </div>
                <p class="form-text text-muted">Selecione esta opção para permitir o usuário informar a validade da proposta comercial nos orçamentos e pedidos</p>
            </li>             
            <li class="list-group-item">
                <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" [(ngModel)]="entity.podeSimularPedido" name="podeSimularPedido" id="podeSimularPedido">
                    <label class="custom-control-label" for="podeSimularPedido">Simular Pedidos</label>
                </div>
                <p class="form-text text-muted">Selecione esta opção para permitir o usuário criar e gerenciar simulações de pedidos</p>
            </li>              
            
            <li class="list-group-item list-group-item-title" aria-disabled="true">
                <div class="list-group-item-title">Dados</div>
                <small class="list-group-item-value">
                    Dados sensíveis dos pedidos que podem ser visualizados
                </small>
            </li>      
            <li class="list-group-item">
                <label class="col-form-label">Resultado e lucratividade dos pedidos</label>
                <sgt-select-usuario-nivel-visualizacao-pedido-drp
                    [value]="entity.nivelVisualizacaoResultadoPedido"
                    (changed)="entity.nivelVisualizacaoResultadoPedido = $event">
                </sgt-select-usuario-nivel-visualizacao-pedido-drp>
            </li>             
            

            <!-- <li class="list-group-item text-center" *ngIf="!possuiAlgumaOpcao()">
                <i class="fas fa-info" aria-hidden="true"></i> Nenhuma opção disponível
            </li> -->
        </ul>                               
    </div>
</form>